export const CookiesSection = () => (
  <section>
    <h2>6. Cookies and Tracking Technologies</h2>

    <p>
      We and our Service Providers use cookies and other technologies for
      performance, tracking, analytics and personalization purposes. We may
      share non-identifiable / aggregated extracts of such information with our
      partners for our legitimate business purposes.
    </p>

    <p>
      Cookies are packets of information sent to your web browser and then sent
      back by the browser each time it accesses the server that sent the cookie.
      Some cookies are removed when you close your browser session. These are
      the "Session Cookies". Some last for longer periods and are called
      "Persistent Cookies". We use both types.
    </p>

    <p>
      We use Persistent Cookies to remember your log-in details and make it
      easier for you to log-in the next time you access the Platform. We may use
      this type of cookies and Session Cookies for additional purposes, to
      facilitate the use of the Services' features and tools.
    </p>

    <p>
      Whilst we do not change our practices in response to a "Do Not Track"
      signal in the HTTP header from a browser or mobile application, you can
      manage your cookies preferences, including whether or not to accept them
      and how to remove them, through your browser settings. Please bear in mind
      that disabling cookies may complicate or even prevent you from using the
      Services.
    </p>

    <p>
      We also use analytics tools, including Google Analytics, Hotjar, Pylon,
      and UXCam. These tools help us understand users' behavior on our Sites and
      Platform, including by tracking page content, and click/touch, movements,
      scrolls and keystroke activities.
    </p>

    {/* The URL list has no spaces; let it break so phones don't scroll sideways. */}
    <p className="wrap-anywhere">
      Further information about the privacy practices of our analytics service
      providers is available at: www.google.com/policies/privacy/partners/;
      https://help.uxcam.com/hc/en-us/articles/360004158171;
      https://www.hotjar.com/legal/policies/privacy/;
      https://usepylon.com/privacy
    </p>
  </section>
);
